module.exports = __webpack_public_path__ + "img/ideation-04-keyfeature-sample-06.25df2b09.jpg";